export default "__VITE_ASSET__DQRcnWEE__"